<div class="content">
	<table mat-table [dataSource]="dataSource" >

		<ng-container matColumnDef="id">
			<th mat-header-cell *matHeaderCellDef>Id</th>
			<td mat-cell *matCellDef="let row" >
				<div class="mrn sub">{{ row.id}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="id_patient_survey_link">
			<th mat-header-cell *matHeaderCellDef>Survey Id</th>
			<td mat-cell *matCellDef="let row" >
				<div class="mrn sub">{{ row.id_patient_survey_link}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="appointment_date">
			<th mat-header-cell *matHeaderCellDef>Date</th>
			<td mat-cell *matCellDef="let row" >
				<div class="mrn sub">{{ row.appointment_date | orgDate: "MM/dd/yyyy hh:ss aa"}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="ehr_appointment_type_name">
			<th mat-header-cell *matHeaderCellDef>Type</th>
			<td mat-cell *matCellDef="let row" >
				<div class="mrn sub">{{ row.ehr_appointment_type_name}}</div>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="gotoAppointment(row)" >
		</tr>

	</table>

</div>

